import { useState, useEffect } from "react";
import { Pencil, PlusCircle, Check, X } from "lucide-react";

export const PayoffAddOn = ({ note, readOnly, onSave }) => {
  const body = (note?.body || "").trim();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(body);
  useEffect(() => { setDraft(body); }, [body]);

  if (editing) {
    return (
      <div className="mt-5" data-testid="payoff-addon-edit">
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          autoFocus
          rows={3}
          placeholder="Add details the report can't see: a busy weekend, a new menu, phone calls you heard about, an event that drove traffic..."
          className="w-full bg-slate-900/60 text-white text-sm md:text-base leading-relaxed rounded-xl border border-lime-300/30 focus:border-lime-300/60 focus:outline-none focus:ring-2 focus:ring-lime-300/20 px-4 py-3 placeholder:text-slate-500 resize-y"
          data-testid="payoff-addon-textarea"
        />
        <div className="mt-3 flex justify-end gap-2">
          <button type="button" onClick={() => { setDraft(body); setEditing(false); }} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-slate-300 hover:text-white hover:bg-white/5 text-xs font-medium transition-colors" data-testid="payoff-addon-cancel">
            <X className="w-3.5 h-3.5" /> Cancel
          </button>
          <button type="button" onClick={async () => { if (await onSave(draft.trim())) setEditing(false); }} className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-lg bg-lime-300 hover:bg-lime-200 text-slate-900 text-xs font-bold transition-colors" data-testid="payoff-addon-save">
            <Check className="w-3.5 h-3.5" /> Save
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      {body && (
        <p className="mt-5 text-slate-100 text-lg md:text-2xl leading-relaxed whitespace-pre-wrap" data-testid="payoff-addon-text">{body}</p>
      )}
      {!readOnly && (
        <button
          type="button"
          onClick={() => setEditing(true)}
          className="mt-4 inline-flex items-center gap-1.5 text-lime-300/80 hover:text-lime-200 text-xs font-semibold transition-colors"
          data-testid="payoff-addon-btn"
        >
          {body ? <Pencil className="w-3.5 h-3.5" /> : <PlusCircle className="w-3.5 h-3.5" />}
          {body ? "Edit your added details" : "Add details the report doesn't show"}
          <span className="text-slate-500 font-normal">(clients will see this)</span>
        </button>
      )}
    </>
  );
};
